import {SNACKBAR_DURATION_MEDIUM} from "../../constants";
import {nsFa} from "../fa/fn";
import {global} from "../../appContext";
import {memoryStore} from "../../util/memorystore";
import {reInitStore} from "../../util/sessionstore";
import {nsAmplify} from "../../util/nsAmplify";
import i = nsFa.i;

export namespace nsSettings {

    export const deleteLocalData = () => {
        let keys = Object.keys(nsAmplify.store());
        keys.forEach((key: string) => {
            if (['storedOrganizationId', 'selected.company.login'].includes(key) && global.loginManager.isUserSA()) {
                return;
            }
            nsAmplify.store(key, null);
        });
        global.snackbarData({
            message: `${i("fa-undo")} ((restored standard settings))`,
            duration: SNACKBAR_DURATION_MEDIUM
        });
    }

    export function discardAllSettings() {
        memoryStore.removeAll()
        reInitStore();
        deleteLocalData();
    }
}
